<template>
  <div
    v-if="visible"
    class="masiva-actions"
  >
    <el-button
      v-if="store.hayErrores"
      data-test="decidir-continuar"
      type="warning"
      :disabled="store.procesando"
      @click="store.abrirDecision()"
      >Decidir cómo continuar</el-button
    >
    <el-button
      v-else
      data-test="procesar-lote"
      type="primary"
      :loading="store.procesando"
      :disabled="store.procesando"
      @click="confirmarProcesar"
      >Procesar lote ({{ store.filasCorrectas.length }})</el-button
    >
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ElMessageBox } from 'element-plus';
import { useCotizacionMasivaStore } from '../stores/cotizacion_masiva_store.js';
import { useMasivaProcesar } from '../composables/use_masiva_procesar.js';

const store = useCotizacionMasivaStore();
const { procesar } = useMasivaProcesar();

// Con errores el botón abre el diálogo de decisión; sin errores procesa directo (con confirmación).
const visible = computed(
  () =>
    store.fase === 'validacion' &&
    store.hayResultado &&
    (store.hayErrores || store.filasCorrectas.length > 0),
);

const confirmarProcesar = async () => {
  try {
    await ElMessageBox.confirm(
      `Se generarán cotizaciones para ${store.filasCorrectas.length} filas. Esta acción crea registros definitivos.`,
      'Procesar lote',
      { confirmButtonText: 'Procesar', cancelButtonText: 'Cancelar', type: 'info' },
    );
  } catch {
    return;
  }
  await procesar();
};
</script>

<style scoped>
.masiva-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
